import axios from 'axios';

// Login API endpoint'ini environment variable'dan al
const LOGIN_API_URL = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/account/login';

/**
 * Kullanıcı girişi yapmak için API'ye istek atar.
 * @param {string} username Kullanıcı adı (veya email)
 * @param {string} password Şifre
 * @returns {Promise<object>} Başarılı olursa API'den dönen veri objesini döner.
 * @throws {Error} İstek başarısız olursa veya ağ hatası olursa hata fırlatır.
 */
export const loginUser = async (username, password) => {
    if (!LOGIN_API_URL) {
        console.error("Login API URL is not defined in environment variables.");
        throw new Error("Giriş yapılandırması eksik.");
    }

    try {
        console.log(`Attempting login for ${username} to ${LOGIN_API_URL}`);
        const response = await axios.post(LOGIN_API_URL, {
            username: username,
            password: password,
        });
        // Axios 2xx status kodlarını başarılı kabul eder ve buraya gelir.
        console.log('Login API success response:', response.data);
        return response.data; // Başarılı yanıtın verisini döndür
    } catch (error) {
        console.error('Login API request failed:', error);
        // Axios hatalarını daha anlaşılır hale getirelim
        if (error.response) {
            // API'den yanıt geldi ama status 2xx değil (örn. 401, 400)
            const apiErrorData = error.response.data;
            const errorMessage = apiErrorData?.message || apiErrorData?.detail || 'Giriş başarısız. Sunucudan hata mesajı alınamadı.';
            console.error('Login API Error Response Data:', apiErrorData);
            throw new Error(errorMessage); // API'den gelen veya genel bir hata mesajı fırlat
        } else if (error.request) {
            // İstek yapıldı ama yanıt alınamadı (ağ hatası, sunucu kapalı vb.)
            console.error('Login Network Error (No response received):', error.request);
            throw new Error('API sunucusuna ulaşılamadı. Ağ bağlantınızı kontrol edin.');
        } else {
            // İsteği ayarlarken bir hata oluştu
            console.error('Login Request Setup Error:', error.message);
            throw new Error('Giriş isteği gönderilirken bir hata oluştu.');
        }
    }
};

/**
 * Kullanıcı çıkışı yapar. localStorage'ı temizler ve rol değişikliği event'ini tetikler.
 */
export const logoutUser = () => {
    // LocalStorage'ı temizle
    localStorage.removeItem('profileURL');
    localStorage.removeItem('token');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('Name');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('userRole');
    localStorage.removeItem('login');
    
    // Rol değişikliği event'ini tetikle
    window.dispatchEvent(new CustomEvent('userRoleChanged'));
    
    console.log('User logged out and role change event triggered');
};

// İleride buraya diğer auth ile ilgili servis fonksiyonları eklenebilir
// export const registerUser = async (...) => { ... };
// export const forgotPassword = async (...) => { ... };